export enum RealmType {
    TITAN_EXTERNAL = 2,
    TITAN_INTERNAL = 1,
    TITAN_GUEST = 3
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/realm-type.enum.ts